import { FundLocalQuotasAPI } from "../API/fund_local_quotas";
import {
    formatAnbimaDateToPt
} from '../components/utils/utils';

import _ from 'lodash';


/**
 * @param {Array} seriesList lista de séries obtidas da API 
 * @param {Array} date data que se refere ao mês que deve ser salva a quotização Ex: 01/01/2021 (Primeiro dia do mês)
 * @returns {obj} objFormatado
 */
export function trySaveListLocalQuotas(seriesList, date) {

    console.log("TENTANDO SALVANDO SERIES: ", seriesList);
    console.log("DATE: ", date);
    let splittedDate = date.split('/');

    let month = parseInt(splittedDate[1]);
    let year = parseInt(splittedDate[2]);

    console.log("MONTH: ", month);
    console.log("YEAR: ", year);

    seriesList.forEach(element => {
        //console.log("Iniciando save quota: ", element);
        doSaveLocalQuotas(element, date, month, year)
    });

};

/**
 * @param {Array} infosList lista de informações obtidas da API  
 * @returns {obj} objFormatado
 */
export async function trySaveListLocalInfos(infosList) {

    let responseSaveLocalInfos = await Promise.all(

        infosList.map(async obj => {

            let response = await FundLocalQuotasAPI.updateInfosLocalQuotas(obj.fundLocalQuotaId, obj.infos);

            //console.log("RESPONSE LOCAL INFO: ", response);

            if (response.success) {

                return true;

            } else {

                return false;

            }

        })
    )


};

/**
 * @param {Array} infosList lista de informações obtidas da API  
 * @returns {obj} objFormatado
 */
export async function trySaveListLocalInfosByFundId(infosList, month, year) {

    console.log("SALVAR DADOS CADASTRAIS LOCALMENTE: ", infosList);
    let responseSaveLocalInfos = await Promise.all(

        infosList.map(async obj => {

            let response = await FundLocalQuotasAPI.updateInfosLocalQuotasByFundId(obj.fund_id, obj.infos, month, year);

            //console.log("RESPONSE LOCAL INFO: ", response);

            if (response.success) {

                return true;

            } else {

                return false;

            }

        })
    )


};

/**
 * @param {obj} fundId id do fundo
 * @param {obj} jsonQuotas array de cotas do mês
 * @param {obj} date data to primeiro dia do mês  
 * @param {obj} month mês a ser salvo 
 * @param {obj} year ano a ser salvo 
 * @param {obj} year Se há cotas específicas para clientes ou não, caso haja deixa passar o save mesmo já havendo carteiras fechadas para essas cotas
 * @param {Boolean} onlyIfEmpty quando true o servidor só grava se json_quotas estiver vazio e não
 * contiver cota manual por cliente, devolvendo 409 caso contrário. Usado pelas atualizações em
 * massa; os fluxos que precisam sobrescrever (cadastro do fundo, cota manual) omitem o parâmetro.
 * @returns {obj} objFormatado
 */
export async function doSaveOrUpdateLocalQuotas(fundId, jsonQuotas, date, month, year, withClientsQuota, onlyIfEmpty) {

    let fundLocalQuotas = {
        fund_id: fundId,
        json_quotas: JSON.stringify(jsonQuotas),
        month: month,
        year: year,
        date_quotas: date,
        withClientsQuota: withClientsQuota,
        only_if_empty: onlyIfEmpty === true,
    }

    let response = await FundLocalQuotasAPI.updateLocalJsonQuotas(fundLocalQuotas);

    if (response.success) {
        //console.log("RESPONSE SAVE LOCAL: ", response.body);
        return {
            success: true,
        }
    } else {
        return {
            success: false,
            body: response.body
        }
    }
};

/**
 * @param {obj} serie objeto de serie, contém as séries, o código_anbima e o fund_id
 * @param {obj} month mês a ser salvo 
 * @param {obj} year ano a ser salvo 
 * @returns {obj} objFormatado
 */
export async function doSaveLocalQuotas(serie, date, month, year) {

    let fundLocalQuotas = {
        fund_id: serie.fund_id,
        //anbima_cod: serie.anbimaCod,
        json_quotas: JSON.stringify(serie.serie_historica),
        month: month,
        year: year,
        date_quotas: date,
    }

    let response = await FundLocalQuotasAPI.saveLocalQuotas(fundLocalQuotas);

    if (response.success) {
        //console.log("RESPONSE SAVE LOCAL: ", response.body);
        return {
            success: true,
        }
    } else {
        return {
            success: false,
        }
    }
};


/**
 * @param {obj} cods códigos anbima e fund_ids
 * @param {obj} date  
 * @param {obj} mainKey para saber qual a chave deve ser utilizada pelo mapa de cotas  
 * @param {Integer} clientId a fim de trazer as possíveis múltiplas cotas dos fundos especiais
 * @returns {obj} objFormatado
 */
export async function getLocalQuotasByListFunds(filteredQuotas, cods, date, mainKey, clientId) {

    let historicSeries = await Promise.all(
        cods.map(async obj => {

            //console.log("CHAMANDO OBJ: ", obj);
            let serie = await FundLocalQuotasAPI.getLocalQuotaByFundId(obj.fund_id, date);

            if (serie.success && serie.body && serie.body.rows.length == 1) {
                return {
                    //anbimaCod: obj.anbima_cod,
                    anbima_cod: obj.anbima_cod,
                    fund_id: obj.fund_id,
                    //serie_historica: JSON.parse(serie.body.rows[0].json_quotas),
                    //NEW VALUE QUOTA
                    serie_historica: getClientJsonQuotas(JSON.parse(serie.body.rows[0].json_quotas), clientId),
                };
            } else {

                return serie.body;

            }

        })
    )

    if (Array.isArray(historicSeries)) {

        historicSeries.forEach(element => {

            if (element && element.serie_historica) {

                filteredQuotas[element[mainKey]] = element.serie_historica;

            }

        });
    }

    return filteredQuotas;

}

/**
 * @param {obj} assets ativos a receberem as informações
 * @param {obj} fundLocalQuotaCods códigos de informações locais 
 * @returns {obj} objFormatado
 */
export async function getLocalInfosByListFunds(assets, fundLocalQuotaCods) {

    let localInfos = await Promise.all(
        fundLocalQuotaCods.map(async localFundoQuotaCod => {
            let info = await FundLocalQuotasAPI.getLocalFundInfoById(localFundoQuotaCod);

            //console.log("RESPONSE LOCAL INFO: ", info);

            if (info.success && info.body && info.body.rows.length == 1) {
                return {
                    fund_id: info.body.rows[0].fund_id,
                    infos: JSON.parse(info.body.rows[0].json_fund_infos),
                };
            } else {

                return info.body;

            }

        })
    )

    //console.log("ASSETS: ", assets);

    let mapInfos = {};
    if (Array.isArray(localInfos)) {

        localInfos.forEach(element => {

            mapInfos[element.fund_id] = element.infos;

        });
    }


    let newAssets = [];
    assets.forEach(asset => {

        //Caso haja informações localmente se colocam as informações nos assets;        
        if (mapInfos[asset.fund_id]) {

            //console.log("INSERINDO DADOS VINDO DE LOCAL: ", mapInfos[asset.fund_id]);

            asset = {
                ...asset,
                ...mapInfos[asset.fund_id],
            }

            newAssets.push(asset);

        } else {

            newAssets.push(asset);

        }

    })

    //console.log("NEW ASSETS AFTER INFOS: ", newAssets);

    return newAssets;

}

export async function fillLocalInfosByMonthAndYear(assets, month, year) {

    const responseLocalInfos = await FundLocalQuotasAPI.getLocalInfosByArrayFundsIds(assets.map((el) => {
        return el.fund_id
    }), month, year);

    console.log('responseLocalInfos: ', responseLocalInfos);

    if (responseLocalInfos.success) {
        //do map
        const mapInfo = {};
        responseLocalInfos.body.rows.forEach(info => {

            if (!mapInfo[info.fund_id]) {

                mapInfo[info.fund_id] = info.json_fund_infos ? JSON.parse(info.json_fund_infos) : null;
            }
        });
        console.log('mapInfo: ', mapInfo)

        const assetsWithInfos = [];
        assets.forEach(asset => {

            assetsWithInfos.push({
                ...asset,
                ...mapInfo[asset.fund_id]
            })

        });

        console.log('assetsWithInfos: ', assetsWithInfos);
        return assetsWithInfos;
    }

    return assets;

}

export async function doGetAllLocalQuotasByFundId(fundId) {

    let responseLocalQuotas = await FundLocalQuotasAPI.getAllLocalQuotasByFundId(fundId);

    if (responseLocalQuotas.success) {

        return {
            success: true,
            body: responseLocalQuotas.body,
        }

    } else {

        return {
            success: false,
            body: "Falha ao obter as cotas locais do fundo",
        }
    }

}

export async function doGetAllLocalQuotasByFundIdMonthAndYear(fundId, month, year) {

    let responseLocalQuotas = await FundLocalQuotasAPI.getAllLocalQuotasByFundIdMonthAndYear(fundId, month, year);

    if (responseLocalQuotas.success) {

        return {
            success: true,
            body: responseLocalQuotas.body,
        }

    } else {

        return {
            success: false,
            body: "Falha ao obter as cotas locais do fundo",
        }
    }

}

export async function doGetLocalInfosByFundIdMonthYear(fundId, month, year) {

    let response = await FundLocalQuotasAPI.getLocalInfosByFundIdMonthYear(fundId, month, year);

    if (response.success) {

        return {
            success: true,
            body: response.body,
        }

    } else {

        return {
            success: false,
            body: "Falha ao obter as cotas locais do fundo",
        }
    }

}

export function formatFundLocalQuotasMonthYear(allFundQuotas) {

    let formattedQuotas = {
        years: [],
        yearsWithMonths: {},
        data: {},
        dataInfos: {},
    };

    allFundQuotas.forEach(fundQuotas => {

        if (!formattedQuotas.yearsWithMonths[fundQuotas.year]) {

            formattedQuotas.years.push(fundQuotas.year);
            //formattedQuotas[fundQuotas.year] = [];
            formattedQuotas.yearsWithMonths[fundQuotas.year] = [];

        }

        formattedQuotas.yearsWithMonths[fundQuotas.year].push(fundQuotas.month);

        formattedQuotas.data[fundQuotas.month + "/" + fundQuotas.year] = JSON.parse(fundQuotas.json_quotas);
        formattedQuotas.dataInfos[fundQuotas.month + "/" + fundQuotas.year] = fundQuotas.json_fund_infos ? JSON.parse(fundQuotas.json_fund_infos) : null;
    });

    return formattedQuotas;

}


export async function doCheckHasCotaDayFund(fundId, day) {

    const splittedDate = day.split('/');
    const month = parseInt(splittedDate[1]);
    const year = parseInt(splittedDate[2]);

    const responsejsonQuotas = await FundLocalQuotasAPI.getLocalQuotasByFundMonthYear(fundId, month, year);
    console.log('JSON QUOTAS: ', responsejsonQuotas);
    if (responsejsonQuotas.success) {

        if (responsejsonQuotas.body.rows.length == 0) {
            return false;
        }

        const cotas = JSON.parse(responsejsonQuotas.body.rows[0].json_quotas);
        if (cotas.some(el => formatAnbimaDateToPt(el.data_referencia) == day)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }

}

// última cota não-zero de um array de cotas de um mês
function getLastNonZeroQuota(quotasArray) {
    if (!Array.isArray(quotasArray) || !quotasArray.length) return null;
    const nz = quotasArray.filter(q => q && q.valor_cota != null && q.valor_cota != 0);
    return nz.length ? nz[nz.length - 1].valor_cota : null;
}

// primeira cota não-zero de todo o histórico (rows ordenadas por date_quotas asc)
function getFirstNonZeroQuotaOfHistory(rows) {
    for (const row of rows) {
        const arr = typeof row.json_quotas === 'string' ? JSON.parse(row.json_quotas) : row.json_quotas;
        const nz = (arr || []).filter(q => q && q.valor_cota != null && q.valor_cota != 0);
        if (nz.length) return nz[0].valor_cota;
    }
    return null;
}

/**
 * Rentabilidade do PRÓPRIO fundo (razão de cotas de fechamento de mês),
 * diferente da cota-média de custo do cliente usada em "Meus Fundos".
 * @param {Array} rows linhas de fund_local_quotas ({ month, year, json_quotas }) ordenadas por data
 * @param {number} month mês corrente de referência
 * @param {number} year ano corrente de referência
 * @returns {obj} { rentMonth, rentYear, rent12m, rent24m, rentHistoric } (percentuais ou null)
 */
export function computeQuotaRentsByMonthYear(rows, month, year) {
    const empty = { rentMonth: null, rentYear: null, rent12m: null, rent24m: null, rentHistoric: null };
    if (!Array.isArray(rows) || !rows.length || !month || !year) return empty;

    const { data } = formatFundLocalQuotasMonthYear(rows);
    const lastOf = (m, y) => getLastNonZeroQuota(data[m + "/" + y]);

    const nowQuota = lastOf(month, year);
    if (nowQuota == null || nowQuota == 0) return empty;

    const pm = month === 1 ? 12 : month - 1;
    const pmy = month === 1 ? year - 1 : year;

    const rent = (base) => (base != null && base != 0) ? ((nowQuota / base) - 1) * 100 : null;

    return {
        rentMonth: rent(lastOf(pm, pmy)),        // mês anterior
        rentYear: rent(lastOf(12, year - 1)),    // Dez do ano anterior (YTD)
        rent12m: rent(lastOf(pm, pmy - 1)),      // mês anterior, 1 ano atrás
        rent24m: rent(lastOf(pm, pmy - 2)),      // mês anterior, 2 anos atrás
        rentHistoric: rent(getFirstNonZeroQuotaOfHistory(rows)), // primeira cota do histórico
    };
}

export function getClientJsonQuotas(jsonQuotas, clientId, fundId) {

    //Datas em que a cota deste cliente está faltando, para um único log por fundo/cliente/mês
    const missingDates = [];

    if (jsonQuotas) {

        jsonQuotas.forEach(quota => {

            quota = getValueQuota(quota, clientId);

            if (quota && quota.client_quota_missing) {
                missingDates.push(quota.data_referencia);
            }

        });
    }

    if (missingDates.length) {
        console.log(`[COTA-CLIENTE] fundo ${fundId != null ? fundId : '?'}: sem valor_cota_${clientId} em `
            + missingDates.join(', ')
            + ` — seguindo com o valor_cota default, que em fundo special é placeholder`);
    }

    return jsonQuotas;

}

/**
 * Em fundo `special` a cota real vive em `valor_cota_<client_id>` e o `valor_cota` default é um
 * placeholder — ele nasce literalmente como 1 em NewSpecialClientQuotaModal. Quando o dia traz a
 * chave de OUTRO cliente e não a deste, o default não é fallback legítimo: é dado faltando.
 * Fundo que não usa cota por cliente nunca dispara. Ver COTA_POR_CLIENTE_FUNDO_SPECIAL.md.
 */
export function hasOtherClientQuota(quota, clientId) {

    if (!quota || !clientId) return false;

    return Object.keys(quota).some(key => /^valor_cota_\d+$/.test(key)
        && key !== 'valor_cota_' + clientId);
}

//Sem async de propósito: não há await aqui e o retorno é usado de forma síncrona pelos chamadores
export function getValueQuota(quota, clientId) {

    if (clientId && quota['valor_cota_' + clientId]) {

        //console.log("ENTROU COTA CLIENTE: ", _.cloneDeep(quota));

        quota.valor_cota_default = quota.valor_cota;
        quota.valor_cota = quota['valor_cota_' + clientId];

        //console.log("SAIU COTA CLIENTE: ", _.cloneDeep(quota));

        return quota;
    }

    //Marca sem alterar o valor: quem consome decide o que fazer com um dia sem cota do cliente
    if (hasOtherClientQuota(quota, clientId)) {
        quota.client_quota_missing = true;
    }

    return quota;
}

